import React from 'react'
import ConversationItem from './ConversationItem'
import { Conversation } from '../../types/messages'

interface ConversationsListProps {
  conversations: Conversation[]
  selectedConversation: number | null
  onSelectConversation: (id: number) => void
  loading: boolean
}

const ConversationsList = ({
  conversations,
  selectedConversation,
  onSelectConversation,
  loading
}: ConversationsListProps) => {
  if (loading && conversations.length === 0) {
    return (
      <div className='loading-container'>
        <div className='spinner-border text-primary' role='status'>
          <span className='sr-only'>Ładowanie...</span>
        </div>
        <p className='mt-3'>Ładowanie konwersacji...</p>
      </div>
    )
  }

  if (!loading && conversations.length === 0) {
    return (
      <div className='tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-10 tw-text-center tw-text-gray-500'>
        <i className='far fa-comments tw-text-4xl tw-text-gray-400 tw-mb-3' />
        <p className='tw-font-medium'>Brak konwersacji</p>
        <p className='tw-text-sm tw-mt-1'>Rozpocznij nową, aby ją tutaj zobaczyć.</p>
      </div>
    )
  }

  return (
    <div className='tw-space-y-2 md:tw-space-y-3'>
      {conversations.map(conversation => (
        <ConversationItem
          key={conversation.id}
          conversation={conversation}
          isSelected={selectedConversation === conversation.id}
          onClick={() => onSelectConversation(conversation.id)}
        />
      ))}
    </div>
  )
}

export default ConversationsList
